import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { EcommerceService } from 'src/app/services/ecommerce.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-placement-history-dialog',
  templateUrl: './placement-history-dialog.component.html',
  styleUrls: ['./placement-history-dialog.component.scss']
})
export class PlacementHistoryDialogComponent implements OnInit {

  @Input() storeId: string = '';
  @Input() productId: string = '';
  @Input() productName: string = '';

  placements: any[] = [];
  loading = false;

  constructor(
    private dialogRef: NbDialogRef<PlacementHistoryDialogComponent>,
    private ecommerceService: EcommerceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    if (this.storeId && this.productId) {
      this.loadHistory();
    }
  }

  loadHistory(): void {
    this.loading = true;
    this.ecommerceService.getProductPlacementHistory(this.storeId, this.productId).subscribe({
      next: (res: any) => {
        const data = res?.response?.data ?? res?.data;
        this.placements = Array.isArray(data) ? data : (data?.placements || []);
        this.loading = false;
      },
      error: (err: any) => {
        this.toastr.error(err?.error?.response?.message || 'Failed to load placement history');
        this.loading = false;
      }
    });
  }

  formatPlacementSummary(placement: any): string {
    const parts = [
      placement.area,
      placement.aisle ? `Aisle ${placement.aisle}` : '',
      placement.section ? `Section ${placement.section}` : '',
      placement.shelf ? `Shelf ${placement.shelf}` : '',
      placement.position ? `Pos ${placement.position}` : ''
    ].filter(Boolean);
    return parts.join(' · ') || '—';
  }

  formatDate(value: string): string {
    if (!value) {
      return '—';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }
    return date.toLocaleString();
  }

  close(): void {
    this.dialogRef.close();
  }
}
